import kiara1 from './PhotoGallery/kiara1.jpg';
import kiara2 from './PhotoGallery/kiara2.jpg';
import kiara3 from './PhotoGallery/kiara3.jpg';
import kiara4 from './PhotoGallery/kiara4.jpg';
import family1 from './PhotoGallery/family1.jpg';
import family2 from './PhotoGallery/family2.jpg';
import family3 from './PhotoGallery/family3.jpg';
import family4 from './PhotoGallery/family4.jpg';
import bday1 from './PhotoGallery/bday1.jpg';
import bday2 from './PhotoGallery/bday2.jpg';
import bday3 from './PhotoGallery/bday3.jpg';
import bday4 from './PhotoGallery/bday4.jpg';
import baptism1 from './PhotoGallery/baptism1.jpg';
import baptism2 from './PhotoGallery/baptism2.jpg';
import baptism3 from './PhotoGallery/baptism3.jpg';
import baptism4 from './PhotoGallery/baptism4.jpg';
import elmer701 from './PhotoGallery/elmer701.jpg';
import elmer702 from './PhotoGallery/elmer702.jpg';
import elmer703 from './PhotoGallery/elmer703.jpg';
import elmer704 from './PhotoGallery/elmer704.jpg';
import andres1 from './PhotoGallery/andres1.jpg';
import andres2 from './PhotoGallery/andres2.jpg';
import andres3 from './PhotoGallery/andres3.jpg';
import andres4 from './PhotoGallery/andres4.jpg';
import angelie1 from './PhotoGallery/angelie1.jpg';
import angelie2 from './PhotoGallery/angelie2.jpg';
import angelie3 from './PhotoGallery/angelie3.jpg';
import angelie4 from './PhotoGallery/angelie4.jpg';
// function importAll(r) {
//   return r.keys().map(r);
// }
// const images = importAll(
//   require.context("./PhotoGallery/", false, /\.(png|jpe?g|svg)$/)
// );

/* <img src={images["doggy.png"]} />; */

export const fashion = [
  {
    src: kiara1,
    width: 4,
    height: 6,
  },
  {
    src: kiara3,
    width: 3,
    height: 2,
  },
  {
    src: kiara2,
    width: 4,
    height: 6,
  },
  {
    src: kiara4,
    width: 3,
    height: 2,
  },
  {
    src: family3,
    width: 4,
    height: 6,
  },
  {
    src: family1,
    width: 3,
    height: 2,
  },
  {
    src: family4,
    width: 4,
    height: 6,
  },
  {
    src: family2,
    width: 3,
    height: 2,
  },
  {
    src: bday1,
    width: 4,
    height: 6,
  },
  {
    src: bday3,
    width: 3,
    height: 2,
  },
  {
    src: bday2,
    width: 4,
    height: 6,
  },
  {
    src: bday4,
    width: 3,
    height: 2,
  },
  {
    src: baptism1,
    width: 4,
    height: 6,
  },
  {
    src: baptism3,
    width: 3,
    height: 2,
  },
  {
    src: baptism2,
    width: 4,
    height: 6,
  },
  {
    src: baptism4,
    width: 3,
    height: 2,
  },
  {
    src: elmer701,
    width: 4,
    height: 6,
  },
  {
    src: elmer703,
    width: 3,
    height: 2,
  },
  {
    src: elmer702,
    width: 4,
    height: 6,
  },
  {
    src: elmer704,
    width: 3,
    height: 2,
  },
  {
    src: andres1,
    width: 4,
    height: 6,
  },
  {
    src: andres3,
    width: 3,
    height: 2,
  },
  {
    src: andres2,
    width: 4,
    height: 6,
  },
  {
    src: andres4,
    width: 3,
    height: 2,
  },
  {
    src: angelie1,
    width: 4,
    height: 6,
  },
  {
    src: angelie3,
    width: 3,
    height: 2,
  },
  {
    src: angelie2,
    width: 4,
    height: 6,
  },
  {
    src: angelie4,
    width: 3,
    height: 2,
  },
];
